import { LogicalOrFilter } from '@cubejs-client/core';
import { createContext, useContext } from 'react';
import { validate as validateUuid } from 'uuid';

import { UserHitId } from '~/components/UserAutocomplete';

import { ResponsibleUsersContextValue } from './ResponsibleUsersProvider.types.ts';

export const ResponsibleUsersContext = createContext<ResponsibleUsersContextValue>({
  users: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUsers: () => {},
});

export const useResponsibleUsers = () => {
  return useContext(ResponsibleUsersContext);
};

export const useResponsibleUsersFilter = (responsibleUserField: string): LogicalOrFilter => {
  const { users } = useResponsibleUsers();
  const userIds = users?.filter(validateUuid);

  return {
    or: [
      ...(userIds?.length
        ? [
            {
              member: responsibleUserField,
              operator: 'equals' as const,
              values: userIds as string[],
            },
          ]
        : []),
      ...(users?.includes(UserHitId.EMPTY) ? [{ member: responsibleUserField, operator: 'notSet' as const }] : []),
    ],
  };
};
